module.exports = {
  API_URL: process.env.REACT_APP_API_URL,
  API_URL_LS: process.env.REACT_APP_API_URL_LS,
  API_URL_HD: process.env.REACT_APP_API_URL_HD,
  SITE: process.env.REACT_APP_SITE
  // SITE: 'SHBET'
};
